import { useEscapeById, useModal } from 'shared/lib/modal';
import { ModalCard } from '../../cards/modalCard';
import { Flex } from '../../flex';
import { Typography } from '../../typography';
import { ButtonsContainer, Circle, MarginBottom } from './styles';
import { Img } from '../../imgStyledComponent';
import marker from 'assets/icons/exclamation-mark.svg';
import { FC, Fragment, useMemo } from 'react';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';
import { CustomError } from 'shared/api';

interface ModalNotificationProps {
	onClose?: () => void;
	error: CustomError | null;
}

const fieldNameMap: {
	[name: string]: string;
} = {
	hold_resources: 'Опция «Стол не менять»',
	bypass: 'Опция «Ручное бронирование»',
	dt_start: 'Дата/время',
	duration: 'Длительность',
	participants_count: 'Количество гостей',
	notes: 'Комментарий к бронированию',
	tags: 'Тэги бронирования',
	prepayment_amount: 'Депозит',
	is_confirmed: 'Подтверждение',
	person: 'Гость',
	'person.name': 'Имя гостя',
	'person.phone': 'Телефон гостя',
	'person.notes': 'Комментарий к гостю',
	'person.tags': 'Тэги гостя',
}

export const ModalError: FC<ModalNotificationProps> = ({
	onClose,
	error,
}) => {
	const { closeModal } = useModal();

	const close = () => {
		onClose?.();
		closeModal();
	};

	const isObject = (value: any) => {
		return value !== null && typeof value === 'object';
	}

	const isShowErrorFields = error?.status === 400;

	const title = useMemo(() => {
		if (error?.status === 400) {
			return 'Упс! Случилась редкая ошибка. Всё в порядке, покажите это окно техподдержке';
		}

		if (error?.status === 500) {
			return 'Ой! Что-то случилось на сервере. Мы уже работаем над этим. Попробуйте через 3 минуты еще раз';
		}

		if (error?.status?.toString()?.startsWith('5')) {
			return 'Странно, но сервер не ответил вовремя. Попробуйте еще раз позже, пожалуйста';
		}

		if (error?.code === 'ERR_NETWORK') {
			return 'На вашем компьютере нет доступа в Интернет';
		}

		return error?.message;
	}, [error])

	useEscapeById('error-modal');

	const renderErrors = (object: object, group?: string) => {
		return Object.entries(object).map(([name, errors]) => {
			return (
				<Fragment key={name}>
					<span>{(fieldNameMap[name] || fieldNameMap[`${group}.${name}`] || name)}:</span>
					<ul style={{ listStyleType: 'initial' }}>
						{Array.isArray(errors) ? errors.map(errorItem => <li key={errorItem}>{errorItem}</li>) : isObject(errors) ? renderErrors(errors, 'person') : null}
					</ul>
				</Fragment>
			)
		})
	}

	return (
		<ModalCard styles={{ cardVariant: 'default' }} onClose={onClose} id="error-modal">
			<MarginBottom>
				<Flex $justify="center">
					<Circle>
						<Img src={marker} $size="giant" />
					</Circle>
				</Flex>
			</MarginBottom>
			<MarginBottom>
				<Flex $justify="center">
					<Typography
						mode={'large'}
						isBold={true}
						textAlignCenter={true}
					>
						{title}
					</Typography>
				</Flex>
				{error?.fields && isShowErrorFields ? <Flex $justify="start">
					<Typography
						mode="medium"
						style={{ marginTop: '16px', marginLeft: '16px' }}
					>
						{renderErrors(error.fields)}
					</Typography>
				</Flex> : null}
			</MarginBottom>
			<ButtonsContainer>
				<Flex $justify="center" $direction="column" $gap="15px">
					<ButtonOutlined onClick={close}>Закрыть</ButtonOutlined>
				</Flex>
			</ButtonsContainer>
		</ModalCard>
	);
};
